import React from 'react';

// styles
import {
  GearListHeaderRow,
  GearListCell,
  GearAvatarDiv,
  SearchHeadingDivP1pa,
} from '../styles';

const SearchHeading = () => {
  return (
    <GearListHeaderRow>
      <GearAvatarDiv />
      <GearListCell>
        <SearchHeadingDivP1pa>Nickname</SearchHeadingDivP1pa>
      </GearListCell>
      <GearListCell>
        <SearchHeadingDivP1pa>Type</SearchHeadingDivP1pa>
      </GearListCell>
      <GearListCell>
        <SearchHeadingDivP1pa>Status</SearchHeadingDivP1pa>
      </GearListCell>
      <GearListCell>
        <SearchHeadingDivP1pa>Start Date</SearchHeadingDivP1pa>
      </GearListCell>
      <GearListCell>
        <SearchHeadingDivP1pa>End Date</SearchHeadingDivP1pa>
      </GearListCell>
      <GearListCell>
        <SearchHeadingDivP1pa>Plan</SearchHeadingDivP1pa>
      </GearListCell>
      <GearListCell>
        <SearchHeadingDivP1pa>Support End date</SearchHeadingDivP1pa>
      </GearListCell>
      <GearListCell>
        <SearchHeadingDivP1pa>Edit Setting</SearchHeadingDivP1pa>
      </GearListCell>
    </GearListHeaderRow>
  );
};

export default SearchHeading;
